import React from 'react'
import ReactMarkdown from 'react-markdown'
import NextLink from 'next/link'
import { Typography, Row, Col } from 'antd'
import BrokerTradingTools from 'components/broker/BrokerTradingTools'
import AddFaq from 'components/shared/AddFaq'
import ArticleList from 'components/shared/ArticleList'
import Button from 'components/shared/button'
import normalizeSlug from 'components/shared/utils/NormalizeSlug'
import { countryNameToId, ProsCons } from 'shared/util'
import ProsAndCons from '../shared/ProsAndCons'
import AccountOpeningCharges from './AccountOpeningCharges'
import CommodityFOBrokrage from './CommodityFOBrokrage'
import CompareBrokerQuickLinks from './CompareBrokerQuickLinks'
import CompareMoreBrokers from './CompareMoreBrokers'
import ConsolidatedCharges from './ConsolidatedCharges'
import CurrencyFOBrokrage from './CurrencyFOBrokrage'
import Exposure from './Exposure'
import OtherBrokersQL from './OtherBrokersQL'

const header = ({ broker1, broker2 }) => {
  return `${broker1.attributes.name} vs ${
    broker2.attributes.name
  } Comparison: ${new Date().getFullYear()}`
}

const ReadMoreLink = ({ slug }) => (
  <div style={{ width: '100%', textAlign: 'right' }}>
    <NextLink href="/broker/[slug]" as={`/broker/${slug}`}>
      ... Read More
    </NextLink>
  </div>
)

export default function CompareBroker({
  brokers,
  all_brokers: allBrokers,
  articles,
}) {
  const { Title } = Typography
  const [broker1, broker2] = brokers
  const countryId = countryNameToId(broker1.attributes.country.name)
  const pros_cons1 = broker1.attributes.pros_cons
  const name1 = broker1.attributes.name
  const pros_cons2 = broker2.attributes.pros_cons
  const name2 = broker2.attributes.name
  const { pros: pros1, cons: cons1 } = ProsCons(pros_cons1)
  const { pros: pros2, cons: cons2 } = ProsCons(pros_cons2)
  const input = {
    broker: broker1.id,
    country: countryId,
    article_type: 'faq',
    page_url: `${normalizeSlug(
      broker1.attributes.slug.toLowerCase()
    )}_vs_${normalizeSlug(broker2.attributes.slug.toLowerCase())}`,
  }

  return (
    <Row className="page-wrapper page" gutter={[16, 16]}>
      <Title className="title-wrapper">{header({ broker1, broker2 })}</Title>
      <Col xs={24} md={16}>
        {brokers.map((broker, idx) => {
          const { name, details, slug } = broker.attributes
          return (
            <Row key={idx}>
              <Col>
                <Title level={4} className="title-wrapper">
                  {`About ${name}`}
                </Title>
                <ReactMarkdown>
                  {details.split(' ', 150).join(' ')}
                </ReactMarkdown>
                <ReadMoreLink slug={slug} />
              </Col>
            </Row>
          )
        })}
        <Row className="row-wrapper">
          <Col>
            <AccountOpeningCharges brokers={brokers} />
          </Col>
        </Row>
        <Row className="row-wrapper">
          <Col>
            <ConsolidatedCharges brokers={brokers} />
          </Col>
        </Row>
        <Row className="row-wrapper">
          <Col>
            <Exposure brokers={brokers} />
          </Col>
        </Row>
        <Row className="row-wrapper">
          <Col>
            <Button
              size="large"
              type="primary"
              source="cb-zerodha-account-button"
            >
              Open FREE Equity Investment Account with Zerodha
            </Button>
          </Col>
        </Row>
        <Row className="row-wrapper">
          <Col>
            <CurrencyFOBrokrage brokers={brokers} />
          </Col>
        </Row>
        <Row className="row-wrapper">
          <Col>
            <CommodityFOBrokrage brokers={brokers} />
          </Col>
        </Row>

        {pros1.length > 0 &&
          cons1.length > 0 &&
          pros2.length > 0 &&
          cons2.length > 0 && (
            <>
              <Row className="row-wrapper">
                <ProsAndCons pros={pros1} cons={cons1} name={name1} />
              </Row>
              <Row className="row-wrapper">
                <ProsAndCons pros={pros2} cons={cons2} name={name2} />
              </Row>
            </>
          )}

        <Row className="row-wrapper">
          <AddFaq input={input} />
        </Row>
        <Row className="row-wrapper">
          <ArticleList articles={articles} />
        </Row>
        <Row className="row-wrapper">
          <Col>
            <CompareMoreBrokers brokers={brokers} all_brokers={allBrokers} />
          </Col>
        </Row>
      </Col>
      <Col xs={24} md={8}>
        <CompareBrokerQuickLinks brokers={brokers} />
        <BrokerTradingTools broker={broker1.attributes} />
        <BrokerTradingTools broker={broker2.attributes} />
        <OtherBrokersQL allBrokers={allBrokers} currentBrokers={brokers} />
      </Col>
    </Row>
  )
}
